// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AHaSr","modal":"Navbar_modal__3hZct","stack":"Navbar_stack__XdcyZ"};